import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: '1rem',
  },
  button: {
    marginLeft: '1rem',
    marginRight: '1rem',
  },
  filterButton: {
    marginLeft: '1rem',
  },
  loader: {
    width: '4rem',
  },
  table: {
    backgroundColor: theme.palette.primary.background,
  },
  clientSelector: {
    width: '20%',
    marginRight: '1rem',
    paddingTop: '1rem',
  },
  clientSelectorLabel: {
    color: theme.palette.text.light,
  },
}));

export default useStyles;
